// // import { Link } from 'react-router-dom';
// // import '../styles/home.scss';

// // import Slide1 from '../assets/slider/home1-slider1.webp';

// // export default function HeroSection() {
// //   const slide = {
// //     image: Slide1,
// //     heading: 'Build With Confidence',
// //     text: 'Discover authentic craftsmanship from Kenya’s finest makers — from custom-made pieces to ready-made products.',
// //     align: 'left',
// //     customButton: {
// //       text: 'Request Custom Work',
// //       link: '/client-dashboard',
// //       icon: '🎨'
// //     },
// //     readyButton: {
// //       text: 'Browse Ready-Made',
// //       link: '/ready-made-products',
// //       icon: '🛍️'
// //     }
// //   };

// //   return (
// //     <section className="hero-section">
// //       <div
// //         className="hero-slide active"
// //         style={{ backgroundImage: `url(${slide.image})` }}
// //       >
// //         <div className="overlay"></div>

// //         <div
// //           className={`content-container container ${
// //             slide.align === 'left' ? 'align-left' : 'align-right'
// //           }`}
// //         >
// //           <p className="subtitle">Welcome to Artiza</p>
// //           <h1>{slide.heading}</h1>
// //           <p className="description">{slide.text}</p>

// //           <div className="button-group">
// //             <Link
// //               to={slide.customButton.link}
// //               className="btn btn-outline-light px-4 py-2 fw-semibold hero-btn custom-btn"
// //             >
// //               <span className="btn-icon">{slide.customButton.icon}</span>
// //               {slide.customButton.text}
// //             </Link>

// //             <Link
// //               to={slide.readyButton.link}
// //               className="btn btn-light px-4 py-2 fw-semibold hero-btn ready-btn"
// //             >
// //               <span className="btn-icon">{slide.readyButton.icon}</span>
// //               {slide.readyButton.text}
// //             </Link>
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// // src/components/Hero.jsx
// import React from 'react';
// import { Link } from 'react-router-dom';
// import {
//   FaPalette,
//   FaStore,
//   FaStar,
//   FaHammer,
//   FaCheckCircle,
//   FaTruck,
//   FaAward,
//   FaUsers,
//   FaBoxOpen,
//   FaShieldAlt,
// } from 'react-icons/fa';
// import '../styles/home.scss';
// const HERO_AVATARS = [
//   'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=80&h=80&fit=crop',
//   'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop',
//   'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop',
//   'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=80&h=80&fit=crop',
// ];

// const HERO_STATS = [
//   { icon: <FaUsers />,     value: '1,200+', label: 'Verified artisans' },
//   { icon: <FaBoxOpen />,   value: '4,500+', label: 'Projects delivered' },
//   { icon: <FaStar />,      value: '4.8★',   label: 'Average rating' },
//   { icon: <FaShieldAlt />, value: '100%',   label: 'Secure payments' },
// ];

// export default function HeroSection() {
//   return (
//     <section className="hero-section">
//       {/* Background decoration */}
//       <div className="hero-pattern" />
//       <span className="hero-blob hero-blob-1" />
//       <span className="hero-blob hero-blob-2" />
//       <span className="hero-blob hero-blob-3" />

//       <div className="hero-inner">
//         {/* LEFT — text */}
//         <div className="hero-text">
//           <span className="hero-eyebrow">
//             <span className="dot" />
//             Kenya's marketplace for bespoke woodwork
//           </span>

//           <h1 className="hero-title">
//             Build with <span className="gradient-text">confidence.</span>
//             <span className="hero-accent">Craft with trust.</span>
//           </h1>

//           <p className="hero-subtitle">
//             Discover authentic craftsmanship from Kenya's finest makers — from
//             custom-made pieces to ready-made products. Negotiate transparently,
//             track progress, and get delivery on your terms.
//           </p>

//           <div className="hero-actions">
//             <Link to="/client-dashboard" className="hero-btn hero-btn-solid">
//               <FaPalette />
//               Request Custom Work
//             </Link>
//             <Link to="/ready-made-products" className="hero-btn hero-btn-ghost">
//               <FaStore />
//               Browse Ready-Made
//             </Link>
//           </div>

//           <div className="hero-trust">
//             <span className="trust-avatars">
//               {HERO_AVATARS.map((src, i) => (
//                 <img key={i} src={src} alt="Artisan" />
//               ))}
//             </span>
//             <span className="trust-text">
//               <strong>1,200+ artisans</strong> already building on Artiza
//             </span>
//           </div>
//         </div>

//         {/* RIGHT — floating preview card */}
//         <div className="hero-visual">
//           <div className="float-card">
//             <div className="float-card-image">
//               <img
//                 src="https://images.unsplash.com/photo-1449247709967-d4461a6a6103?w=800&h=800&fit=crop"
//                 alt="Featured piece"
//               />
//               <span className="float-card-badge">
//                 <FaAward /> Featured
//               </span>
//             </div>
//             <div className="float-card-body">
//               <h4>Mahogany Dining Table</h4>
//               <p className="float-card-artisan">
//                 <FaHammer /> Mwangi Woodworks · Nairobi
//               </p>
//               <div className="float-card-rating">
//                 {[1, 2, 3, 4, 5].map((s) => (
//                   <FaStar key={s} />
//                 ))}
//                 <span>4.9 (128)</span>
//               </div>
//             </div>
//           </div>

//           <div className="float-chip float-chip-top">
//             <FaCheckCircle /> Milestone approved
//           </div>
//           <div className="float-chip float-chip-bottom">
//             <FaTruck /> Out for delivery
//           </div>
//         </div>
//       </div>

//       {/* Trust bar */}
//       <div className="hero-stats">
//         {HERO_STATS.map((s, i) => (
//           <div className="hero-stat" key={i}>
//             <span className="hero-stat-icon">{s.icon}</span>
//             <div className="hero-stat-text">
//               <strong>{s.value}</strong>
//               <span>{s.label}</span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// src/components/Hero.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaPalette,
  FaStore,
  FaStar,
  FaCheckCircle,
  FaTruck,
  FaShieldAlt,
  FaUsers,
  FaBoxOpen,
  FaHammer,
  FaAward,
} from 'react-icons/fa';
import Slide1 from '../assets/slider/home1-slider1.webp';
import '../styles/home.scss';

const HERO_STATS = [
  { icon: <FaUsers />,     value: '1,200+', label: 'Verified artisans' },
  { icon: <FaBoxOpen />,   value: '4,500+', label: 'Projects delivered' },
  { icon: <FaStar />,      value: '4.8★',   label: 'Average rating' },
  { icon: <FaShieldAlt />, value: '100%',   label: 'Secure payments' },
];

export default function HeroSection() {
  return (
    <section className="hero-section">
      {/* Background image */}
      <div
        className="hero-bg"
        style={{ backgroundImage: `url(${Slide1})` }}
      />

      {/* Layered overlays for depth */}
      <div className="hero-overlay" />
      <div className="hero-overlay-side" />
      <div className="hero-pattern" />

      {/* Decorative glows */}
      <span className="hero-blob hero-blob-1" />
      <span className="hero-blob hero-blob-2" />

      {/* =============================================
          CONTENT
         ============================================= */}
      <div className="hero-inner">
        <div className="hero-text">
          <span className="hero-eyebrow">
            <span className="dot" />
            Kenya's marketplace for bespoke woodwork
          </span>

          <h1 className="hero-title">
            Build with <span className="gradient-text">confidence.</span>
            <span className="hero-accent">Craft with trust.</span>
          </h1>

          <p className="hero-subtitle">
            Discover authentic craftsmanship from Kenya's finest makers — from
            custom-made pieces to ready-made products. Negotiate transparently,
            track progress, and get delivery on your terms.
          </p>

          <div className="hero-actions">
            <Link to="/client-dashboard" className="hero-btn hero-btn-solid">
              <FaPalette />
              Request Custom Work
            </Link>
            <Link to="/ready-made-products" className="hero-btn hero-btn-ghost">
              <FaStore />
              Browse Ready-Made
            </Link>
          </div>

          <div className="hero-trust">
            <span className="trust-rating">
              {[1, 2, 3, 4, 5].map((s) => (
                <FaStar key={s} />
              ))}
            </span>
            <span className="trust-text">
              <strong>4.8</strong> average from <strong>1,200+ artisans</strong>
            </span>
          </div>
        </div>

        {/* Floating status chips on the right side of the hero */}
        {/* <div className="hero-visual">
          <div className="float-chip float-chip-top">
            <FaCheckCircle /> Milestone approved
          </div>
          <div className="float-chip float-chip-mid">
            <FaHammer /> Artisan matched in 4 hrs
          </div>
          <div className="float-chip float-chip-bottom">
            <FaTruck /> Out for delivery
          </div>
          <div className="float-badge">
            <FaAward />
            <span>Verified artisans</span>
          </div>
        </div> */}
      </div>

      {/* =============================================
          TRUST BAR
         ============================================= */}
      <div className="hero-stats">
        {HERO_STATS.map((s, i) => (
          <div className="hero-stat" key={i}>
            <span className="hero-stat-icon">{s.icon}</span>
            <div className="hero-stat-text">
              <strong>{s.value}</strong>
              <span>{s.label}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}